import { render, staticRenderFns } from "./SocialPostDropzone.vue?vue&type=template&id=32c62fd8"
import script from "./SocialPostDropzone.vue?vue&type=script&lang=js"
export * from "./SocialPostDropzone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports